(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tav-chevet-bundle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('form:updated', (event) => {
  if (!event.target.matches('product-form')) return;
  const offer = event.target.querySelector('[data-chevet-discount="5"]');
  if (!offer) return;
  const selected = Number(event.target.querySelector('input[name="quantity"]')?.value) >= 2;
  const prices = event.detail?.prices;
  offer.dataset.selected = String(selected);
  offer.querySelector('[data-chevet-prices]').hidden = !selected;
  if (!selected || !prices) return;
  const money = new Intl.NumberFormat(offer.dataset.locale || 'fr', { style: 'currency', currency: offer.dataset.currency || 'EUR' });
  offer.querySelector('[data-chevet-regular]').textContent = money.format(prices.compare_at_price / 100);
  offer.querySelector('[data-chevet-total]').textContent = money.format(prices.price / 100);
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-chevet-duo]');
  if (!button) return;
  const quantity = button.closest('form')?.querySelector('input[name="quantity"]');
  if (!quantity || quantity.disabled || (Number(quantity.max) > 0 && Number(quantity.max) < 2)) return;
  quantity.value = '2';
  quantity.dispatchEvent(new Event('change', { bubbles: true }));
});
  } catch(e) { console.error(e); }
})();

})();
